import 'sass/artist-cms.entry.scss';
import './shims/promise.js';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'mobx-react';
import createBrowserHistory from 'history/createBrowserHistory';
import { RouterStore, syncHistoryWithStore } from 'mobx-react-router';
import {
	apiStore,
	formStore,
	userStore,
	songsStore,
	artistStore,
	genreStore,
	playlistStore,
	statsStore,
	albumsStore,
	eventStore
} from 'client/shared/stores';

import Root from './components/root';
import sessionManager from 'client/shared/session/session-manager';

// Initialize the session manager after stores are ready. It schedules the
// warning/logout timers based on the current access token's exp claim and
// wires activity listeners for silent refresh.
sessionManager.init(userStore);

const browserHistory = createBrowserHistory();
const routingStore = new RouterStore();
const history = syncHistoryWithStore(browserHistory, routingStore);

const providerAttrs = {
	history,
	routingStore,
	apiStore,
	formStore,
	userStore,
	songsStore,
	artistStore,
	genreStore,
	playlistStore,
	statsStore,
	albumsStore,
	eventStore
};

ReactDOM.render(
	<Provider { ...providerAttrs }>
		<Root />
	</Provider>,
	document.getElementById('app')
);

if (module.hot) {

	module.hot.accept();
}
